'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-216/node_modules/@eliadmin/core/src/components/claim/claim-form.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-216/node_modules/@eliadmin/core/src/components/claim/claim-form.tsx").ClaimForm>>;
const Deferred = lazy(() => import("@eliadmin/module-original/claimForm").then(m => ({ default: m.ClaimForm })));
export function ClaimForm(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

